<template>
  <v-row no-gutters>
    <v-col cols="12" class="d-flex align-center">
      <template v-for="(listItem, index) in sideBarItems">
        <template v-if="listItem.subItems &&
                        Array.isArray(listItem.subItems) &&
                        listItem.subItems.length > 0 && listItem.shownCondition">
          <v-menu right
                  bottom
                  :key="index">
            <template v-slot:activator="{ on: menu }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    icon
                    height="38px"
                    width="38px"
                    v-on="{ ...tooltip, ...menu }"
                  >
                    <template v-if="listItem.image">
                      <img :src="listItem.image.srcWhite"
                           style="width: 22px"
                           :alt="listItem.image.alt">
                    </template>
                    <template v-else>
                      <v-icon :color="isCloudTask ? 'kbBlue' : 'white'" size="22px">
                        {{ listItem.icon.name }}
                      </v-icon>
                    </template>
                  </v-btn>
                </template>
                <span>{{ listItem.name }}</span>
              </v-tooltip>
            </template>

            <v-row>
              <v-col cols="12" class="py-0">
                <v-list color="kbLight">
                  <v-list-item v-for="(subItem, ind) in listItem.subItems"
                               :key="`subItem-${ind}`"
                               @click="subItem.itemFunction()">
                    <v-list-item-content>
                      <v-list-item-title class="kbDarkBlueText--text">
                        {{ subItem.name }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-menu>
        </template>

        <template v-else-if="listItem.shownCondition">
          <v-tooltip bottom :key="index">
            <template v-slot:activator="{ on }">
              <v-btn
                @click="listItem.itemFunction()"
                icon
                height="38px"
                width="38px"
                v-on="on"
              >
                <template v-if="listItem.image">
                  <img :src="isCloudTask ? listItem.image.srcCloudtask : listItem.image.srcWhite"
                       style="width: 22px"
                       :alt="listItem.image.alt">
                </template>
                <template v-else>
                  <v-icon :color="isCloudTask ? 'kbBlue' : 'white'" size="22px">
                    {{ listItem.icon.name }}
                  </v-icon>
                </template>
              </v-btn>
            </template>
            <span>{{ listItem.name }}</span>
          </v-tooltip>
        </template>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import SideBarMixin from '@/mixins/components/SideBarMixin'
import { mapGetters, mapState } from 'vuex'
export default {
  computed: {
    ...mapGetters(['administratorRoles', 'sidebarModules']),
    ...mapState({
      isCloudTask: state => state.auth.isCloudTask,
      selectedCompany: state => state.companies.selectedCompany,
      selectedApp: state => state.apps.selectedApp
    })
  },
  data () {
    return {
      tab: 0
    }
  },
  mixins: [SideBarMixin]
}
</script>
